<template>
  <div class="background-form">
    <div class="title">足球背景</div>
    <div class="form">
      <van-form ref="backgroundForm" input-align="right" error-message-align="right">
        <van-cell-group>
          <!-- 球龄 -->
          <van-field
            v-model="formData.years"
            label="球龄"
            placeholder="请选择球龄"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择球龄' }]"
            @click="showYearsPicker = true"
          />
          
          <!-- 运动频率 -->
          <van-field
            v-model="formData.taringFrequency"
            label="运动频率"
            placeholder="请选择运动频率"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择运动频率' }]"
            @click="showFrequencyPicker = true"
          />
          
          <!-- 是否接受过训练 -->
          <van-field
            v-model="formData.traingHistory"
            label="是否接受过训练"
            placeholder="请选择是否接受过训练"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择是否接受过训练' }]"
            @click="showTrainingHistoryPicker = true"
          />
          
          <!-- 训练时长 -->
          <van-field
            v-if="formData.traingHistory !== '未接受过正式的足球训练'"
            v-model="formData.traingDuration"
            label="训练时长"
            placeholder="请选择训练时长"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择训练时长' }]"
            @click="showDurationPicker = true"
          />
          
          <!-- 历史参赛 -->
          <van-field
            v-model="formData.competitionHistory"
            label="历史参赛"
            placeholder="请选择历史参赛"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择历史参赛' }]"
            @click="showCompetitionPicker = true"
          />
          
          <!-- 惯用脚 -->
          <van-field
            v-model="formData.preferredFoot"
            label="惯用脚"
            placeholder="请选择惯用脚"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择惯用脚' }]"
            @click="showFootPicker = true"
          />
          
          <!-- 特点标签 -->
          <van-field
            v-model="characteristicDisplayText"
            label="特点标签"
            placeholder="请选择特点标签"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择特点标签' }]"
            @click="showCharacteristicPicker = true"
          />
          
          <!-- 踢球照片或视频 -->
          <van-field
            readonly
          >
           <template #input>
              <div class="media-upload-section">
                <div class="upload-info">
                  <span class="upload-label">踢球照片与视频</span>
                  <span class="upload-constraints">非必填, 文件最大50MB</span>
                </div>
                <van-uploader
                  v-model="sportMediaList2"
                  :max-count="3"
                  :after-read="afterRead"
                  @delete="onDelete"
                  :accept="acceptTypes"
                  class="custom-uploader"
                >
                  <div class="upload-placeholder">
                    <van-icon name="plus" class="plus-icon" />
                    <span class="upload-text">添加文件</span>
                  </div>
                </van-uploader>
              </div>
            </template>
          </van-field>
        </van-cell-group>
      </van-form>
    </div>

    <!-- 球龄选择器 -->
    <van-popup v-model="showYearsPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="yearsOptions"
        @confirm="onYearsConfirm"
        @cancel="showYearsPicker = false"
      />
    </van-popup>

    <!-- 运动频率选择器 -->
    <van-popup v-model="showFrequencyPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="frequencyOptions"
        @confirm="onFrequencyConfirm"
        @cancel="showFrequencyPicker = false"
      />
    </van-popup>

    <!-- 训练历史选择器 -->
    <van-popup v-model="showTrainingHistoryPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="trainingHistoryOptions"
        @confirm="onTrainingHistoryConfirm"
        @cancel="showTrainingHistoryPicker = false"
      />
    </van-popup>

    <!-- 训练时长选择器 -->
    <van-popup v-model="showDurationPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="durationOptions"
        @confirm="onDurationConfirm"
        @cancel="showDurationPicker = false"
      />
    </van-popup>

    <!-- 历史参赛选择器 -->
    <van-popup v-model="showCompetitionPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="competitionOptions"
        @confirm="onCompetitionConfirm"
        @cancel="showCompetitionPicker = false"
      />
    </van-popup>

    <!-- 惯用脚选择器 -->
    <van-popup v-model="showFootPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="footOptions"
        @confirm="onFootConfirm"
        @cancel="showFootPicker = false"
      />
    </van-popup>

    <!-- 特点标签选择器 -->
    <van-popup v-model="showCharacteristicPicker" position="bottom">
      <div class="characteristic-picker">
        <div class="picker-header">
          <span @click="showCharacteristicPicker = false">取消</span>
          <span>选择特点标签</span>
          <span @click="onCharacteristicConfirm">确定</span>
        </div>
        <div class="picker-content">
          <van-checkbox-group v-model="selectedCharacteristics">
            <van-cell-group>
              <van-cell
                v-for="item in characteristicOptions"
                :key="item"
                :title="item"
                clickable
                @click="toggleCharacteristic(item)"
              >
                <template #right-icon>
                  <van-checkbox :name="item" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Form, Field, Icon, Popup, Picker, CellGroup, Uploader, Checkbox, Cell, Toast} from "vant";
Vue.use(Form).use(Field).use(Icon).use(Popup).use(Picker).use(CellGroup).use(Uploader).use(Checkbox).use(Cell).use(Toast)
import { uploadImage } from "@/api/qiniu";
import { QNImageUtil } from "@/utils";

export default {
  props: {
    qiniuToken: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        years: '',
        taringFrequency: '',
        traingHistory: '',
        traingDuration: '',
        competitionHistory: '',
        preferredFoot: '',
        characteristic: '',
        sportMedia: []
      },
      // 选择器显示状态
      showYearsPicker: false,
      showFrequencyPicker: false,
      showTrainingHistoryPicker: false,
      showDurationPicker: false,
      showCompetitionPicker: false,
      showFootPicker: false,
      showCharacteristicPicker: false,
      
      // 选项数据
      yearsOptions: ['3年以内', '3-5年', '5-10年', '10年以上'],
      frequencyOptions: ['极少', '每月1-3场', '每周1-2场', '每周3场以上'],
      trainingHistoryOptions: ['未接受过正式的足球训练', '在学校社团活校队','在青少年足球俱乐部','职业队或少体校'],
      durationOptions: ['3个月以内', '3-6个月', '6-12个月', '1-3年', '3-5年', '5年以上'],
      competitionOptions: ['地方一级业余及校园赛事', '省一级业余及校园赛事','全国性业余及校园足球赛事','国内国际青少年综合赛事','职业足球赛事','国际大赛'],
      footOptions: ['左脚', '右脚', '左右均衡'],
      characteristicOptions: ['防守铁闸','后撤组织','全能中场','擅长前插','万金油','组织核心','边路快马','盘带高手','禁区之狐','柱式中锋'],
      // 用于多选特点标签的选中状态
      selectedCharacteristics: [],
      sportMediaList2: [],
      acceptTypes: 'image/*,video/*',
    };
  },
  watch: {
    form: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          // 避免循环更新，只在数据真正不同时才更新
          if (JSON.stringify(this.formData) !== JSON.stringify(newVal)) {
            this.formData = JSON.parse(JSON.stringify(newVal));
            // 处理特点标签的多选状态
            if(newVal.characteristic){
              // 处理多种可能的数据格式
              let characteristics = [];
              if (typeof newVal.characteristic === 'string') {
                // 字符串格式，按逗号分割并去除空格
                characteristics = newVal.characteristic.split(',').map(item => item.trim()).filter(item => item);
              } else if (Array.isArray(newVal.characteristic)) {
                // 数组格式
                characteristics = newVal.characteristic;
              }
              this.selectedCharacteristics = characteristics;
            } else {
              // 如果没有数据，清空选中状态
              this.selectedCharacteristics = [];
            }
            
            // 手动同步特点标签状态，确保一致性
            this.syncCharacteristicState();
            // 处理媒体文件列表
            if(newVal.sportMedia && newVal.sportMedia.length > 0) {
              this.sportMediaList2 = [...newVal.sportMedia];
            }
          }
        }
      },
      deep: true,
      immediate: true
    },
    // 移除formData的watch，避免循环
    sportMediaList: {
      handler(newVal) {
        this.sportMediaList2 = newVal.map(item => {
          if (!item.isImage) { 
            item.url = item.url + '?vframe/jpg/offset/0'
            item.isImage = true
          }
          return item
        })
      },
      deep: true
    }
  },
  computed: {
    characteristicDisplayText() {
      return this.selectedCharacteristics.join(', ');
    },
    sportMediaList() {
      if(!this.formData.sportMedia) return []
      return this.formData.sportMedia
    }
  },
  methods: {
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.originView(img)
    },
    // 球龄确认
    onYearsConfirm(value) {
      this.formData.years = value;
      this.showYearsPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 运动频率确认
    onFrequencyConfirm(value) {
      this.formData.taringFrequency = value;
      this.showFrequencyPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 训练历史确认
    onTrainingHistoryConfirm(value) {
      this.formData.traingHistory = value;
      this.showTrainingHistoryPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 训练时长确认
    onDurationConfirm(value) {
      this.formData.traingDuration = value;
      this.showDurationPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 历史参赛确认
    onCompetitionConfirm(value) {
      this.formData.competitionHistory = value;
      this.showCompetitionPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 惯用脚确认
    onFootConfirm(value) {
      this.formData.preferredFoot = value;
      this.showFootPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 特点标签确认
    onCharacteristicConfirm() {
      // 确保数据格式一致，过滤空值
      const validCharacteristics = this.selectedCharacteristics.filter(item => item && item.trim());
      this.formData.characteristic = validCharacteristics.join(', ');
      this.showCharacteristicPicker = false;
      this.$emit('update:form', { ...this.formData });
    },

    // 切换特点标签选中状态
    toggleCharacteristic(name) {
      const index = this.selectedCharacteristics.indexOf(name);
      if (index > -1) {
        this.selectedCharacteristics.splice(index, 1);
      } else {
        this.selectedCharacteristics.push(name);
      }
    },
    // 文件上传后处理
    afterRead(file) {
      console.log(file,'file');
      const type = file.file.type
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.formData))
        if (player.sportMedia && player.sportMedia.length > 0) {
          player.sportMedia.push({url: this.imageView(res.hash), id: res.hash, isImage: type.startsWith('image/')})
        } else {
          player.sportMedia = [{url: this.imageView(res.hash), id: res.hash, isImage: type.startsWith('image/')}]
        }
        this.formData = player
        this.$emit('update:form', { ...this.formData })
      }).catch(err => {
        this.$toast('文件上传失败')
        console.error('上传失败:', err)
      })
    },
    
    // 删除文件
    onDelete(file) {
      const player = JSON.parse(JSON.stringify(this.formData))
      const list = player.sportMedia
      const index = list.findIndex(item => item.id === file.id)
      if (index > -1) {
        list.splice(index, 1)
      }
      player.sportMedia = list
      this.formData = player
      this.$emit('update:form', { ...this.formData })
    },
    
    // 获取表单数据
    getFormData() {
      return this.formData;
    },
    
    // 重置表单
    resetForm() {
      this.formData = {
        years: '',
        taringFrequency: '',
        traingHistory: '',
        traingDuration: '',
        competitionHistory: '',
        preferredFoot: '',
        characteristic: '',
        sportMedia: []
      };
      this.selectedCharacteristics = []; // 重置选中状态
      this.sportMediaList2 = []; // 重置媒体文件列表
    },
    
    // 手动同步特点标签状态
    syncCharacteristicState() {
      if (this.formData.characteristic) {
        let characteristics = [];
        if (typeof this.formData.characteristic === 'string') {
          characteristics = this.formData.characteristic.split(',').map(item => item.trim()).filter(item => item);
        } else if (Array.isArray(this.formData.characteristic)) {
          characteristics = this.formData.characteristic;
        }
        this.selectedCharacteristics = characteristics;
      } else {
        this.selectedCharacteristics = [];
      }
    },
    
    // 验证表单
    validateForm() {
      return this.$refs.backgroundForm.validate()
    }
  }
};
</script>

<style scoped lang="scss">
.background-form{
  .title{
    background-color: #F5F5F5;
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
  }
}
::v-deep .van-cell{
  min-height: 54px;
  box-sizing: border-box;
  align-items: center;
}
::v-deep .van-field__label{
  color: rgba(0, 0, 0, 0.9);
}
::v-deep .van-field__control{
  font-weight: 500;
}
::v-deep .van-uploader{
  width: 100% !important;
}
::v-deep .van-uploader__wrapper{
  display: flex;
  justify-content: flex-end;
}

.characteristic-picker {
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    font-size: 16px;
    color: #323233;
  }

  .picker-content {
    max-height: 300px;
    overflow-y: auto;
  }
}

// 自定义上传器样式
.media-upload-section {
  width: 100%;
  
  .upload-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    
    .upload-label {
      font-size: 14px;
      color: #323233;
      font-weight: 500;
    }
    
    .upload-constraints {
      font-size: 12px;
      color: #969799;
    }
  }
}

::v-deep .custom-uploader {
  .van-uploader__wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
  }
  
  .van-uploader__preview {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #ebedf0;
    position: relative;
    
    .van-uploader__preview-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .van-uploader__preview-delete {
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }
    
    // 视频文件特殊样式
    &.video-preview {
      .video-play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 32px;
        height: 32px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
      }
    }
  }
  
  .upload-placeholder {
    width: 80px;
    height: 80px;
    border: 1px dashed #dcdee0;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fafafa;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: #1989fa;
      background-color: #f0f9ff;
    }
    
    .plus-icon {
      font-size: 20px;
      color: #969799;
      margin-bottom: 4px;
    }
    
    .upload-text {
      font-size: 12px;
      color: #969799;
      text-align: center;
      line-height: 1.2;
    }
  }
}
</style>
